var _defs, _rect, _rect2, _g, _g2, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInStockOnly(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1152,
    zoomAndPan: "magnify",
    viewBox: "0 0 864 863.999991",
    height: 1152,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "9349c95047"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 136 51.246094 L 758 51.246094 L 758 734 L 136 734 Z M 136 51.246094 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "9c1f16f32d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 12.34375 433.453125 L 378.34375 433.453125 L 378.34375 799.453125 L 12.34375 799.453125 Z M 12.34375 433.453125 ",
    clipRule: "nonzero"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -86.4,
    width: 1036.8,
    fill: "#ffffff",
    y: -86.399999,
    height: 1036.79999,
    fillOpacity: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -86.4,
    width: 1036.8,
    fill: "#ffffff",
    y: -86.399999,
    height: 1036.79999,
    fillOpacity: 1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#9349c95047)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#111931",
    d: "M 136.027344 554.515625 L 433.019531 725.988281 L 446.519531 733.792969 L 460.019531 725.964844 L 757.011719 554.488281 L 757.011719 230.496094 L 446.519531 51.246094 L 136.027344 230.523438 Z M 730.011719 538.9375 L 460.019531 694.804688 L 460.019531 417.574219 L 730.011719 261.652344 Z M 446.519531 82.40625 L 716.511719 238.300781 L 595.015625 308.472656 L 325.023438 152.574219 Z M 298.023438 168.15625 L 568.042969 324.023438 L 446.519531 394.195312 L 176.523438 238.328125 Z M 163.023438 261.679688 L 433.019531 417.601562 L 433.019531 694.804688 L 163.023438 538.9375 Z M 163.023438 261.679688 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#9c1f16f32d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#111931",
    d: "M 195.300781 433.453125 C 94.265625 433.453125 12.34375 515.375 12.34375 616.410156 C 12.34375 717.445312 94.265625 799.371094 195.300781 799.371094 C 296.335938 799.371094 378.261719 717.445312 378.261719 616.410156 C 378.261719 515.375 296.335938 433.453125 195.300781 433.453125 Z M 298.269531 588.171875 L 191.222656 695.222656 C 186.066406 700.375 179.089844 703.273438 171.789062 703.273438 C 164.59375 703.273438 157.613281 700.375 152.460938 695.222656 L 98.992188 641.75 C 88.253906 631.011719 88.253906 613.726562 98.992188 602.988281 C 109.726562 592.359375 126.90625 592.359375 137.644531 602.988281 L 171.789062 637.242188 L 259.507812 549.519531 C 270.246094 538.78125 287.53125 538.78125 298.269531 549.519531 C 308.898438 560.148438 308.898438 577.4375 298.269531 588.171875 Z M 298.269531 588.171875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 298.269531 588.171875 L 191.222656 695.222656 C 186.066406 700.375 179.089844 703.273438 171.789062 703.273438 C 164.59375 703.273438 157.613281 700.375 152.460938 695.222656 L 98.992188 641.75 C 88.253906 631.011719 88.253906 613.726562 98.992188 602.988281 C 109.726562 592.359375 126.90625 592.359375 137.644531 602.988281 L 171.789062 637.242188 L 259.507812 549.519531 C 270.246094 538.78125 287.53125 538.78125 298.269531 549.519531 C 308.898438 560.148438 308.898438 577.4375 298.269531 588.171875 Z M 298.269531 588.171875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInStockOnly);
export default __webpack_public_path__ + "static/media/InStockOnly.be018be8bcf26c952541ff17ba709dfa.svg";
export { ForwardRef as ReactComponent };